<template>
    <div class="sys_control_container" :class="locale === 'en'?'sys_control_container_en':''">
        <div class="sys_control_main">
            <div class="sys_container">
                <div class="sys_left">
                    <span class="title">{{$t('personalCenter.myProjects')}}</span>
                    <!-- <div style="left: -24px;top: 16px; max-width: 693px;margin-bottom: 16px;" class="divider"></div> -->
                    <div style="height: 1px;"></div>
                    <div v-if="projectList.length" style="height: 868px;">
                        <el-scrollbar>
                            <div v-for=" item in projectList" :key="item.id">
                                <div class="project">
                                    <div class="pro_img"><img class="pro_img" :src="item.projectPicUrl" alt=""></div>
                                    <div class="pro_main">
                                        <div style="font-weight: 500;margin-bottom: 15px;color:#333;">{{ item.userProjectName }}<img
                                                @click="modifyTitle(item.projectId,item.userProjectName)" style="margin-left: 5px;"
                                                src="@/assets/image/edit.svg" alt=""></div>
                                        <div>
                                            <span
                                                @click="router.push({ path: '/downloads', query: { menuId:item.projectId} })"
                                                class="pro_des" ><img src="@/assets/image/proname.svg"
                                                    alt="">{{$t('personalCenter.resourceDownloads')}}</span>
                                            <span class="pro_des pro-des-h"
                                                @click="toDownload(item)"><img
                                                    src="@/assets/image/doc.svg" alt="">{{$t('personalCenter.developmentDocuments')}}</span>
                                            <!-- <span v-if="item.developmentToolDocumentId" class="pro_des pro-des-h"
                                                @click="router.push({ path: '/home/controldocument', query: { type:'tool', projectId: item.projectId ,developmentToolDocumentId:item.developmentToolDocumentId} })"><img
                                                    src="@/assets/image/tools.svg" alt="">开发工具</span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="pro_blank" style="text-align: center;" v-else>
                        <el-empty :image="require('@/assets/image/empty@3x.png')" :image-size="180"
                            :description="description" 
                            class="empty-tip"
                        />
                        <el-button @click="router.push({ path: '/home/controlDeveloperAuth' })" style="margin-top: 15px;" color="#386AEA" v-if="myInfo.authenticationResult == 2100 || myInfo.authenticationResult == 2300">{{$t('personalCenter.certifiedDeveloper')}}</el-button>
                        <!-- <el-button @click="router.push({ path: '/home/controlsupport' })" style="margin-top: 15px;" color="#386AEA">申请项目</el-button> -->
                    </div>
                </div>
                <div class="sys_right">
                    <div class="sys_r_top">
                        <div class="flexlayout">
                            <span class="commonfontstyle">{{$t('personalCenter.accountInformation')}}</span>
                            <span @click="router.push({ path: '/home/controlinformation',query:{type:'first'} })"
                                style="cursor: pointer;font-size: 12px;">{{$t('personalCenter.details')}}<img style="transform: translateY(-2px);"
                                    src="@/assets/image/more.svg" alt=""></span>
                        </div>
                        <div style="font-size: 14px;margin-top: 16px; color: #333;">{{$t('personalCenter.accountName')}}: {{ myInfo.mobile }}</div>
                        <div style="font-size: 14px;margin-top: 16px; color: #333;">{{$t('personalCenter.accountCertification')}}:
                            <span v-if="myInfo.authenticationResult == 2200">{{ myInfo.authenticationType === '1' ? $t('personalCenter.individualDeveloper') :$t('personalCenter.enterpriseDeveloper') }}</span>
                            <span v-else-if="myInfo.authenticationResult == 2400">{{$t('personalCenter.underCertification')}}</span>
                            <span @click="router.push({ path: '/home/controlrealauth' })" v-else class="font_size_mini"
                                style="color: #386AEA;cursor: pointer;text-decoration: underline;">{{$t('personalCenter.goCertify')}}</span>
                        </div>
                    </div>
                    <div class="sys_r_bot">
                        <div style="margin-bottom: 24px;" class="flexlayout">
                            <span class="commonfontstyle">{{$t('personalCenter.systemNotices')}}</span>
                            <span @click="router.push({ path: '/home/controlSysMsg' })"
                                style="cursor: pointer;font-size: 12px;">{{$t('personalCenter.more')}}<img style="transform: translateY(-2px);"
                                    src="@/assets/image/more.svg" alt=""></span>
                        </div>
                        <div style="height: 690px;">
                            <el-scrollbar>
                                <div v-for="item in sysMesList" :key="item.id">
                                    <div class="flexlayout" style="cursor: pointer;">
                                        <div @click="router.push({ path: '/home/controldetail', query: { type: 'sysmessage' ,id:item.id} })"
                                            class="des_two_row " style="width: 252px;font-size: 14px; color: #666;">
                                            {{ item.title }}
                                        </div>
                                        <div style="font-size: 12px; color: #999;">{{ handledate1(item.updateTime) }}</div>
                                    </div>
                                    <div style="margin: 16px 0px;" class="divider"></div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :showClose="false" v-model="centerDialogVisible" :title="$t('personalCenter.modifyProjectName')" width="480px" center>
            <el-form ref="form" :model="projectForm" :rules="rules" label-width="80px">
                <el-form-item prop="projectName">
                    <el-input :placeholder="$t('personalCenter.newProjectName')" :maxlength="50"  v-model="projectForm.projectName"></el-input>
                </el-form-item>

            </el-form>
            <div class="bot_btn">
                <el-button @click="centerDialogVisible = false" color="#666">{{$t('personalCenter.cancel')}}</el-button>
                <el-button @click="updateProName" style="margin-left: 16px;" color="#386AEA">{{$t('personalCenter.confirm')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { getMyProjectApi, getMyInfoApi, getSysNotice, modifyProjectName } from '@/api/control'
import { handledate1 } from '@/utils/common'
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

let projectList = ref([])
let myInfo = ref({})
let sysMesList = ref([])
let projectId = ref('')
const description = ref(t("download.noProjectTips"))

onBeforeMount(() => {
    getMinfomation()
    getMsgList()
})
//获取我的项目
const getProjectList = () => {
    getMyProjectApi().then(res => {
        projectList.value = res.result || []
    }).catch(err => { console.log(err); })
}
const getMinfomation = () => {
    getMyInfoApi().then(res => {
        myInfo.value = res.result
        if(myInfo.value.authenticationResult === 2200) getProjectList()
        if(myInfo.value.authenticationResult === 2100 || myInfo.value.authenticationResult === 2300)description.value = t("personalCenter.pleaseCertification")
    }).catch(err => { console.log(err); })
}
const getMsgList = () => {
    getSysNotice().then(res => {
        sysMesList.value = res.result
    }).catch(err => { console.log(err); })
}
const router = useRouter()
const centerDialogVisible = ref(false)
const projectForm = ref({
    projectName: '',
})
//表单校验规则
const rules = ref({
    // mobile: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
})
const modifyTitle = (Id,name) => {
    projectId.value = Id
    projectForm.value.projectName = name
    centerDialogVisible.value = true
}
const updateProName = () => {
    console.log(projectForm.value.projectName);
    modifyProjectName({ projectId: projectId.value, userProjectName: projectForm.value.projectName }).then(res => {
        if (res.code == 200) {
            getProjectList()
            ElMessage({
                message: res.message,
                customClass: "custom-message1",
            });
        }
    }).catch(err => { console.log(err); })
    centerDialogVisible.value = false
}

const toDownload = (item) => {
    router.push({ path: '/downloads', query: { menuId:item.projectId, showArticle: true }})
}
</script>

<style lang="scss" scoped>
.sys_control_container {
    min-height: calc(100vh - 56px);
    background-color: #f8f8f8;
    .sys_control_main {
        padding: 24px 0px 40px;
    }
}
::v-deep .el-empty__description{
    font-weight: 400!important;
}
::v-deep .el-input__wrapper {
    height: 64px;
    padding: 1px 24px;
    font-size: 16px;
}

::v-deep .el-input__wrapper {
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.2) inset !important;
    background: rgba(0, 0, 0, 0.05)
}
::v-deep .el-input__inner{
    color: #333333;
}
::v-deep .el-input__inner::placeholder {
    color: #000;
    // font-family: PingFang SC;
    font-size: 16px;
    opacity: 0.4;
    font-style: normal;
    font-weight: 400;
    line-height: 200%;
}

::v-deep .el-form-item {
    width: 400px;
    margin: 0 auto;
}

::v-deep .el-form-item__content {
    margin-left: 0px !important;
}

::v-deep .el-dialog__header {
    padding-top: 40px;
    padding-bottom: 15px;
}

::v-deep .el-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    border-radius: 4px;
}

.des_two_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}

::v-deep .el-dialog__title {
    color: #333;
    // font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.pro_blank {
    margin-top: 115px;
    ::v-deep .el-button {
        // width: 232px;
        height: 54px;
        color: #FFF;
        // font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 0 45px;
    }
}

.bot_btn {
    margin: 40px 0px 10px 15px;

    ::v-deep .el-button {
        width: 192px;
        height: 64px;
        color: #FFF;
        // font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}

.flexlayout {
    display: flex;
    justify-content: space-between;
}

.commonfontstyle {
    font-size: 20px;
    font-weight: 500;
}

.font_size_mini {
    font-size: 14px;
    font-weight: 500;
}

.pro_des {
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    // text-decoration-line: underline;
    margin-right: 24px;
    color: #666;
    cursor: pointer;

    img {
        margin-right: 6px;
    }
    &.pro-des-h:hover{
        color: #386AEA;
    }
}

.title {
    color: #000;
    font-size: 20px;
    font-weight: 500;
}

.divider {
    position: relative;
    height: 1px;
}

.divider:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0px;
    right: 0;
    height: 0.5px;
    background-color: rgba(0, 0, 0, 0.1);
}

.sys_container {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .sys_left {
        flex: 1;
        border-radius: 4px;
        background-color: #fff;
        height: 960px;
        padding: 24px;
        font-weight: 700;

        .project {
            display: flex;
            margin: 32px 0px;

            .pro_img {
                width: 80px;
                height: 60px;
                border-radius: 4px;
                background-color: rgba(0, 0, 0, 0.1);
            }

            .pro_main {
                margin-left: 16px;
                flex: 1;

                div{
                    word-break: break-word;
                    white-space: pre-wrap;
                }
                

                img {
                    transform: translateY(-2px);
                    cursor: pointer;
                }
            }
        }


    }

    .sys_right {
        width: 356px;
        margin-left: 16px;
        border-radius: 4px;

        .sys_r_top {
            width: 356px;
            height: 150px;
            border-radius: 4px;
            background: #FFF;
            margin-bottom: 16px;
            padding: 24px;
        }

        .sys_r_bot {
            width: 356px;
            height: 794px;
            border-radius: 4px;
            background: #FFF;
            padding: 16px 24px 32px;
        }
    }

    .empty-tip {
        padding-bottom: 0;
        line-height: 32px;
    }
}

@media (min-width: 1200px) {
    .sys_container {
        width: 1105px;
    }

}

@media (max-width: 1200px) {
    .sys_container {
        width: calc(100vw - 80px);
    }

    // .sys_left{
    // width: calc(100vw - 532px);
    // }

}


// 英文版样式
.sys_control_container_en{
    ::v-deep .el-empty__description p{
        max-width: 300px;
        line-height: 1.5;
        word-break: normal;
    }
}

</style>